import React, {Component, PropTypes} from 'react';
import Immutable from 'immutable';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {shouldComponentUpdate} from 'react-immutable-render-mixin';
import {bindActionCreators}  from 'redux';
import {connect}  from 'react-redux';
import _ from 'lodash';
import {
Editor,
EditorState,
ContentState,
convertToRaw,
convertFromRaw,
RichUtils,
getVisibleSelectionRect,
AtomicBlockUtils,
Modifier,
DefaultDraftBlockRenderMap
} from 'draft-js';
import {stateToHTML} from 'draft-js-export-html';
import FontSizeHandler from '../RichUtils/custom-methods/FontSizeHandler';

import {getProperContentForEditor, getPlaceholder} from './helpers';

import ExtendedRichUtils from '../RichUtils/custom-methods/ExtendedRichUtils';

import './styles.scss';
//
// const blockRenderMap = Immutable.Map({
//     'unstyled': {
//         element: 'div',
//         aliasedElements: ['p'],
//     }
// });

// Include 'paragraph' as a valid block and updated the unstyled element but
// keep support for other draft default block types
// const extendedBlockRenderMap = DefaultDraftBlockRenderMap.merge(blockRenderMap);

/**
 * RichUtils Component
 */
import RichUtilsComponent from '../RichUtils/RichUtilsComponent';

const basePlaceholder = "Placeholder";

export default class DraftComponent extends Component {

    static propTypes = {
        advanced: PropTypes.bool,
        readOnly: PropTypes.bool, // content: PropTypes.string,
        mode: PropTypes.string,
    };

    static defaultProps = {
        placeholder: basePlaceholder,
        canUpdateValue: true,
    };

    constructor(props) {
        super(props);

        const content = getProperContentForEditor(props.content);
        const fontSizeHandler = new FontSizeHandler();

        const fontsMap = fontSizeHandler.prepareStyleObject();

        this.state = {
            editorState: EditorState.createWithContent(content),
            changedProps: true,
            selectionPosition: {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
            },
            placeholder: getPlaceholder(props.mode, basePlaceholder),
            fontsMap: fontsMap,
        };
        this.fontSizeHandler = fontSizeHandler;
        this.shouldComponentUpdate = shouldComponentUpdate.bind(this);
        this.renderRichUtilsWrapper = this.renderRichUtilsWrapper.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChangeUp = _.debounce(this.handleChangeUp.bind(this), 400);
        this.focus = this.focus.bind(this);
        this.renderRichUtils = this.renderRichUtils.bind(this);
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.content !== this.props.content && this.props.canUpdateValue) {
            const content = getProperContentForEditor(nextProps.content);

            this.setState({
                editorState: EditorState.createWithContent(content),
            });
        }
    }

    componentDidUpdate(prevProps) {
        const {mode} = this.props;

        if (mode !== prevProps.mode) {
            this.setState({
                placeholder: getPlaceholder(mode, basePlaceholder)
            })
        }

        // if (!this.props.activeTools && prevProps.activeTools) {
        //     return this.props.onChange(this.state.editorState.getCurrentContent());
        // }
    }

    focus() {
        this.refs.editor.focus();
        // Update caret position
        const position = getVisibleSelectionRect(window);
        if (position !== null) {
            this.setState({
                selectionPosition: position,
            });
        }

    };

    toggleFontSize(toggledSize) {
        const {editorState, fontsMap} = this.state;
        const selection = editorState.getSelection();

        // Let's just allow one font-size at a time. Turn off all active colors.
        const nextContentState = Object.keys(fontsMap)
        .reduce((contentState, fontSize) => {
            return Modifier.removeInlineStyle(contentState, selection, fontSize)
        }, editorState.getCurrentContent());

        let nextEditorState = EditorState.push(editorState, nextContentState, 'change-inline-style');

        const currentStyle = editorState.getCurrentInlineStyle();

        // Unset style override for current font size.
        if (selection.isCollapsed()) {
            nextEditorState = currentStyle.reduce((state, size) => {
                return RichUtils.toggleInlineStyle(state, size);
            }, nextEditorState);
        }

        // If the font size is being toggled on, apply it.
        if (!currentStyle.has(toggledSize)) {
            nextEditorState = RichUtils.toggleInlineStyle(nextEditorState, toggledSize);
        }

        this.onChange(nextEditorState);
    }

    toggleInlineStyle(inlineStyle) {
        console.log('toggling inline style e.g. bold');
        this.setState({
            editorState: RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle)
        });
        this.focus();

    }

    toggleBlockStyle(blockStyle) {
        console.log('toggling inline block style');
        if(blockStyle === 'undefined') {
            return false;
        }

        const {editorState, fontsMap} = this.state;
        const selection = editorState.getSelection();
        const block = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());

        console.log(block);

        // Let's just allow one font-size at a time. Turn off all active colors.
        const nextContentState = Object.keys((fontsMap))
        .reduce((contentState, fontSize) => {
            return Modifier.removeInlineStyle(contentState, selection, fontSize)
        }, editorState.getCurrentContent());

        console.log('disable font size');

        let nextEditorState = EditorState.push(editorState, nextContentState, 'change-inline-style');


        console.log('setting changes style');

        this.setState({
            editorState: RichUtils.toggleBlockType(nextEditorState, blockStyle)
        });

    }

    handleAlignmentChange(style) {
        console.log('toggling alignment');
        this.setState({
            editorState: ExtendedRichUtils.toggleAlignment(this.state.editorState, style)
        });
    }

    handleUndo() {
        this.setState({
            editorState: EditorState.undo(this.state.editorState)
        });

    }

    handleRedo() {
        this.setState({
            editorState: EditorState.redo(this.state.editorState)
        });
    }

    handleChangeUp(){
        this.props.onChange(this.state.editorState.getCurrentContent())
    }

    onChange(editorState) {
        this.handleChangeUp();

        this.setState({
            editorState
        });


    }

    onBlur() {
        this.setState({
            ...this.state,
            placeholder: this.props.placeholder
        });
    }

    onFocus() {
        if (this.state.placeholder !== false) {
            this.setState({
                ...this.state,
                placeholder: false
            })
        }
    }

    renderRichUtils() {
        if (this.props.activeTools) {
            return (
            <RichUtilsComponent editorState={this.state.editorState}
                                onToggle={::this.toggleInlineStyle}
                                onToggleBlock={::this.toggleBlockStyle}
                                onAlignmentChange={::this.handleAlignmentChange}
                                visible={this.props.activeTools}
                                onToggleSize={::this.toggleFontSize}
                                onUndo={::this.handleUndo}
                                fontSizeHandler={this.fontSizeHandler}
                                onRedo={::this.handleRedo}/>
            )
        }

    }

    renderRichUtilsWrapper() {
        if (this.props.advanced) {
            return this.renderRichUtils()
        }

        return null;
    }

    renderEditor() {
        if (this.props.activeEditing) {
            const {editorState} = this.state;
            return (
            <div className="draft_container" onClick={this.focus}>
                {this.renderRichUtilsWrapper()}
                <Editor editorState={editorState}
                        readOnly={this.props.readOnly}
                        onChange={this.onChange}
                        onBlur={::this.onBlur}
                        onFocus={::this.onFocus}
                        placeholder={this.state.placeholder}
                        customStyleMap={this.state.fontsMap}
                        blockStyleFn={(contentBlock)=>{
                                             const textAlignment = contentBlock.getData().get('textAlignment');
                                             switch (textAlignment) {
                                                 case("left"):
                                                     return "align-left";
                                                 case("right"):
                                                     return "align-right";
                                                 case("center"):
                                                     return "align-center";
                                                 case("justify"):
                                                     return "align-justify";
                                                 default:
                                                     return null;
                                             }
                                         }}
                        onClick={()=>{alert('clicked')}}
                        ref="editor"
                />
            </div>
            )
        }
        return (<span>{this.props.content}</span>)
    }

    render() {

        return this.renderEditor()
    }

}


// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/DraftComponent/DraftComponent.js